import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, ArrowLeft, BadgeCheck } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import MembershipCard from "@/components/MembershipCard";
import HireShare from "@/components/HireShare";

export default function Verify() {
  const { membershipId } = useParams();
  const [member, setMember] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    api.get(`/members/verify/${membershipId}`).then((r) => { setMember(r.data); setStatus("ok"); }).catch(() => setStatus("notfound"));
  }, [membershipId]);

  return (
    <main className="pt-24 pb-20 min-h-screen">
      <div className="max-w-lg mx-auto px-5 w-full">
        {status === "loading" && <div className="pt-24 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-[#E6197E]" /></div>}

        {status === "notfound" && (
          <div className="pt-16 text-center">
            <h1 className="font-heading text-2xl font-bold">Membership not found</h1>
            <p className="text-zinc-400 mt-2">The ID <span className="font-mono-accent">{membershipId}</span> is not registered.</p>
            <Link to="/directory"><Button variant="outline" className="mt-6 border-white/15 bg-transparent rounded-full"><ArrowLeft className="w-4 h-4 mr-2" /> Browse Directory</Button></Link>
          </div>
        )}

        {status === "ok" && (
          <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <div className="relative rounded-3xl overflow-hidden mb-8 grain">
              <div className="absolute inset-0">
                {member.photo_path && <img src={fileUrl(member.photo_path)} alt="" className="w-full h-full object-cover opacity-25" />}
                <div className="absolute inset-0 bg-gradient-to-b from-[#0B0C0E]/60 to-[#0B0C0E]" />
              </div>
              <div className="relative px-6 pt-8 pb-6 flex flex-col items-center text-center">
                <div className="w-28 h-28 rounded-full overflow-hidden ring-4 ring-[#E6197E]/60 bg-zinc-800 shadow-xl">
                  {member.photo_path ? <img src={fileUrl(member.photo_path)} alt={member.full_name} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-4xl font-heading">{member.full_name[0]}</div>}
                </div>
                <div className="mt-4 inline-flex items-center gap-1.5 text-xs font-bold text-emerald-400"><BadgeCheck className="w-4 h-4" /> VERIFIED MEMBER</div>
                <h1 className="font-heading text-3xl font-extrabold mt-1">{member.full_name}</h1>
                <p className="text-[#F5A623] font-semibold mt-1">{member.expertise}</p>
                <p className="text-sm text-zinc-400">{member.discipline} · {member.lga} LGA</p>
                {member.bio && <p className="text-sm text-zinc-300 mt-4 max-w-md leading-relaxed">{member.bio}</p>}
                <div className="mt-6"><HireShare member={member} /></div>
              </div>
            </div>

            <MembershipCard member={member} />
            <p className="text-center text-xs text-zinc-500 mt-6">This digital ID confirms the holder is a registered creative of the Nasarawa Expo movement.</p>
          </motion.div>
        )}
      </div>
    </main>
  );
}
